import { useState } from "react";
import { useRouter } from "next/router";

import CategoryBanner from "./Category-Banner";
import { ROUTE } from "@/route/app_routes.js";

const SORT_OPTIONS = [
  { value: "", label: "Most relevant" },
  { value: "newest", label: "Newest" },
  { value: "popular", label: "Most students" },
  { value: "title_asc", label: "Title A–Z" },
];

const LEVEL_OPTIONS = [
  { value: "", label: "All levels" },
  { value: "beginner", label: "Beginner" },
  { value: "intermediate", label: "Intermediate" },
  { value: "advanced", label: "Advanced" },
];

const CoursesPageCategoryHead = ({ category, sort, skillLevel, instructor, instructorName }) => {
  const router = useRouter();
  const [searchTerm, setSearchTerm] = useState(
    typeof router.query.search === "string" ? router.query.search : ""
  );

  const updateQuery = (patch) => {
    const query = { ...router.query };
    delete query.path;
    Object.entries(patch).forEach(([key, value]) => {
      if (value) query[key] = value;
      else delete query[key];
    });
    router.push({ pathname: ROUTE.course, query });
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    updateQuery({ search: searchTerm.trim() });
  };

  const hasActiveFilters = Boolean(category || searchTerm || sort || skillLevel || instructor);

  return (
    <div className="rbt-page-banner-wrapper">
      <CategoryBanner category={category} />

      {instructor && (
        <div className="container">
          <div className="rbt-instructor-filter-chip">
            <i className="feather-user"></i>
            <span>
              Showing courses by <strong>{instructorName || "this instructor"}</strong>
            </span>
            <button
              type="button"
              onClick={() => updateQuery({ instructor: null, instructorName: null })}
              aria-label="Remove instructor filter"
            >
              <i className="feather-x"></i>
            </button>
          </div>
        </div>
      )}

      <div className="rbt-course-filter-bar">
        <div className="container">
          <div className="rbt-course-filter-bar__inner">
            <form className="rbt-course-filter-bar__search" onSubmit={handleSearchSubmit}>
              <i className="feather-search"></i>
              <input
                type="text"
                placeholder="Search courses, topics, technologies…"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button type="submit">Search</button>
            </form>

            <div className="rbt-course-filter-bar__selects">
              <label className="rbt-course-filter-bar__select">
                <span>Level</span>
                <select
                  value={skillLevel}
                  onChange={(e) => updateQuery({ skill_level: e.target.value })}
                >
                  {LEVEL_OPTIONS.map((opt) => (
                    <option value={opt.value} key={opt.value || "all"}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </label>

              <label className="rbt-course-filter-bar__select">
                <span>Sort</span>
                <select value={sort} onChange={(e) => updateQuery({ sort: e.target.value })}>
                  {SORT_OPTIONS.map((opt) => (
                    <option value={opt.value} key={opt.value || "relevant"}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </label>

              {hasActiveFilters && (
                <button
                  type="button"
                  className="rbt-course-filter-bar__clear"
                  onClick={() => {
                    setSearchTerm("");
                    router.push(ROUTE.course);
                  }}
                >
                  Clear all <i className="feather-x"></i>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoursesPageCategoryHead;
